import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useUser } from '../providers/current-user.provider';
import { MenuListLink } from './MenuListLink';
import { SidebarSection } from './SidebarSection';
import {
  SidebarLink,
  SidebarSection as SidebarSectionType,
  isSidebarSection,
  sidebarStructure,
} from './utils';

interface SidebarProps {
  onLinkClick?: () => void;
}

export const SIDEBAR_WIDTH = 240;

export const Sidebar = ({ onLinkClick }: SidebarProps) => {
  const location = useLocation();
  const { user } = useUser();

  const isLinkVisible = (link: SidebarLink) =>
    !link.permission || !!user.adminPermissions?.[link.permission];

  const handleLinkClick = () => onLinkClick?.();

  return (
    <Box
      component="nav"
      sx={{
        width: SIDEBAR_WIDTH,
        flexShrink: 0,
        py: 2,
        px: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
      }}
    >
      {sidebarStructure.map((item) => {
        if (!isSidebarSection(item)) {
          if (!isLinkVisible(item)) return null;
          return (
            <MenuListLink
              key={item.path}
              path={item.path}
              title={item.title}
              Icon={item.Icon}
              isActive={location.pathname === item.path}
              onClose={handleLinkClick}
            />
          );
        }

        const visibleChildren = item.children.filter(isLinkVisible);
        if (visibleChildren.length === 0) return null;

        const activeChild = visibleChildren.find(
          (child) => child.path === location.pathname,
        );

        return (
          <SidebarSection
            key={item.title}
            section={item as SidebarSectionType}
            visibleChildren={visibleChildren}
            activeChildPath={activeChild?.path ?? null}
            onLinkClick={handleLinkClick}
          />
        );
      })}
    </Box>
  );
};
